var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndTrip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "endTrip",
    transform: "translate(-226.5 -564.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tr",
    d: "M17,8h3l3,4.056V18H20.965a3.5,3.5,0,0,1-6.929,0H8.965a3.5,3.5,0,0,1-6.929,0H1V6A1,1,0,0,1,2,5H16a1,1,0,0,1,1,1Zm0,2v3h4v-.285L18.992,10Z",
    transform: "translate(240.5 559.5)",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M128.53,126.818l4.79-4.79a1.211,1.211,0,1,0-1.711-1.714l-4.79,4.79-4.79-4.79a1.212,1.212,0,0,0-1.714,1.714l4.79,4.79-4.79,4.79a1.212,1.212,0,0,0,1.714,1.714l4.79-4.79,4.79,4.79a1.212,1.212,0,0,0,1.714-1.714Z",
    transform: "translate(106.542 445.763)",
    stroke: "#000",
    strokeWidth: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndTrip);
export default __webpack_public_path__ + "static/media/endTrip.507bd0e3ad7fd750798d79dccde842a1.svg";
export { ForwardRef as ReactComponent };